'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var BackButton_module = require('./BackButton.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const BackButton = _ref => {
  let {
    onBack
  } = _ref;
  const handleClick = () => {
    onBack();
  };
  return /*#__PURE__*/React__default["default"].createElement("button", {
    className: BackButton_module["default"].backButtonWrapper,
    onClick: handleClick
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: BackButton_module["default"].bar
  }), /*#__PURE__*/React__default["default"].createElement("div", {
    className: BackButton_module["default"].barReverse
  }));
};

exports.BackButton = BackButton;
